module.exports = __webpack_public_path__ + "static/media/module_badge_rules_and_consequences.e73f69f9.png";